import { FCL_45_HC_FALSY_VALUE_MULTIPLIER } from '../envVariables';
import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name checkFcl45hqPrice
 * @description if property '45hq' is missing/falsy only in a FCL rate card, then add it
 * and it's value should be = (env. variable REACT_APP_FCL_45_HC_FALSY_VALUE_MULTIPLIER) * (40 hq property).
 *
 * @param {Object} fclJSON - Full FCL json
 * @returns {Object}
 */

export const checkFcl45hqPrice = (fclJSON) => {
  let fclFullJson = fclJSON;
  let fclRatesArr = [];

  if (
    !fclFullJson ||
    isEmpty(fclFullJson) ||
    !fclFullJson.rates ||
    !Array.isArray(fclFullJson.rates.fcl) ||
    fclFullJson.rates.fcl.length === 0
  ) {
    return fclFullJson;
  }

  fclFullJson.rates.fcl.map((itemJson) => {
    let tempItemJson = itemJson;
    let fcl45HqRate = Number(tempItemJson['45hq']);
    fcl45HqRate = isNaN(fcl45HqRate) ? 0 : fcl45HqRate;

    if (!fcl45HqRate) {
      let fcl40HqRate = Number(tempItemJson['40hq']);
      fcl40HqRate = isNaN(fcl40HqRate) ? 0 : fcl40HqRate;

      let multiplier = Number(FCL_45_HC_FALSY_VALUE_MULTIPLIER);
      multiplier = isNaN(multiplier) ? 0 : multiplier;

      if (multiplier) {
        fcl45HqRate = Number(fcl40HqRate * multiplier);
      }

      // console.log(fcl40HqRate);

      tempItemJson = { ...tempItemJson, '45hq': `${fcl45HqRate}` };
    }

    fclRatesArr.push(tempItemJson);
  });

  fclFullJson = {
    ...fclFullJson,
    rates: {
      fcl: fclRatesArr,
    },
  };

  return fclFullJson;
};
